import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { ReportJobTypes } from '@vy/types';
import { isNotNullOrUndefined, type Nullable } from '@vy/utils';
import { useMenu } from '../../../../hooks/use-menu';
import type { ReportType } from '../reports-page-types/report-type';
import { REPORT_TYPES } from '../reports-page-types/report-type';
import { getSelectedReportJobForm } from '../reports-page-utils/get-selected-report-form';
import { TriggerReportJobForm } from './trigger-report-job-dialog/TriggerReportJobDialog';

type ReportMenuProps = {
  selectedReportJob?: ReportJobTypes;
  reportType: Nullable<ReportType>;
  onExportCsv?: () => void;
  shouldExportAsCsv: boolean;
  shouldRequestReport: boolean;
};

export const ReportMenu: React.FC<ReportMenuProps> = ({
  selectedReportJob,
  reportType,
  onExportCsv,
  shouldExportAsCsv,
  shouldRequestReport,
}) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();

  const disableRequestReport: ReportType[] = [
    REPORT_TYPES.CUSTOMER_REVENUE,
    REPORT_TYPES.CONTRACTS,
    REPORT_TYPES.RECURRING_REVENUE,
    REPORT_TYPES.ANONYMOUS_CUSTOMERS,
    REPORT_TYPES.MONTHLY_CLOSURE,
    REPORT_TYPES.UNAPPROVED_INVOICES,
    REPORT_TYPES.UPCOMING_INVOICES,
    REPORT_TYPES.FAILED_INVOICE_DELIVERIES,
    REPORT_TYPES.USAGE,
    REPORT_TYPES.USAGE_REPORT_V2,
    REPORT_TYPES.COMMITMENT_VS_USAGE,
    REPORT_TYPES.UNMETERED_EVENTS,
  ];

  return (
    <>
      <IconButton size="medium" onClick={handleMenuOpen}>
        <VyIcon icon="DotsMenu" />
      </IconButton>
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isOpen}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'max-w-[250px] w-full shadow-xl',
          },

          list: {
            className: 'py-0',
          }
        }}>
        <Paper elevation={8}>
          {isNotNullOrUndefined(selectedReportJob) && shouldRequestReport && (
            <TriggerReportJobForm
              reportJobType={selectedReportJob}
              disabled={isNotNullOrUndefined(reportType) && disableRequestReport.includes(reportType)}
              formContent={
                selectedReportJob ? (props) => getSelectedReportJobForm(selectedReportJob, props) : undefined
              }
            />
          )}

          {shouldExportAsCsv && (
            <MenuItem sx={{ height: '50px !important' }} onClick={() => onExportCsv?.()}>
              <ListItemIcon>
                <VyIcon
                  icon="Csv"
                  style={{
                    transform: 'scale(0.8)',
                  }}
                />
              </ListItemIcon>
              <ListItemText>Download as CSV</ListItemText>
            </MenuItem>
          )}
        </Paper>
      </Menu>
    </>
  );
};
